// Define a custom filter filter function!
import intersection from 'lodash/intersection'
import isEqual from 'lodash/isEqual'
import matchSorter from 'match-sorter'

export function filterGreaterThan(rows, id, filterValue) {
    return rows.filter((row) => {
        const rowValue = row.values[id]
        return rowValue >= filterValue
    })
}

export const filterBoolean = (rows, id, filterValue) => {
    return rows.filter((row) => {
        const rowValue = row.values[id]
        const value = filterValue === '1' || filterValue === true
        return rowValue == value
    })
}

filterBoolean.autoRemove = (val) => !val
export const filterDropdown = (rows, id, value) => {
    if (!value) return rows

    const { filterType, filterValue } = value

    if (Array.isArray(filterValue)) {
        filterValue.sort()
    }

    return rows.filter((row) => {
        let rowValue = row.values[id]
        if (Array.isArray(rowValue)) {
            rowValue = rowValue.sort()
        }

        switch (filterType) {
            case 'contains':
                return Array.isArray(rowValue)
                    ? intersection(rowValue, filterValue).length > 0
                    : filterValue.includes(rowValue)
            case 'containsNone':
                return Array.isArray(rowValue)
                    ? intersection(rowValue, filterValue).length < 1
                    : !filterValue.includes(rowValue)
            case 'is':
                return isEqual(filterValue, rowValue)
            case 'isNot':
                return !isEqual(filterValue, rowValue)
        }
    })
}

filterDropdown.autoRemove = (val) => !val

export function fuzzyTextFilterFn(rows, id, filterValue) {
    return matchSorter(rows, filterValue, { keys: [(row) => row.values[id]] })
}

// Let the table remove the filter if the string is empty
fuzzyTextFilterFn.autoRemove = (val) => !val
